import axios from 'axios'
import getConfig from '../configs/config'

const HEALTH_CHECK_ENDPOINT = '/maintenance/health-check-simple'

class _MaintenanceService {
    healthCheck() {
        return axios.get(getConfig().apiBaseUrl + HEALTH_CHECK_ENDPOINT, {
            timeout: 5000,
        }) //not using here API axios instance in order to avoid running interceptors
    }
}

const MaintenanceService = new _MaintenanceService()
export default MaintenanceService
